import gql from 'graphql-tag';

export default gql`
mutation deleteAutoRedirect($groupId: Int!, $fromPath: String!) {
  deleteAutoRedirect(object: { group_id: $groupId, from_path: $fromPath }) {
    affected_rows
  }
}
`;
